const ChipMap = {
    Layout: {
        id: '260216',
        name: 'Layout',
        type: 'struct',
        title: '通栏设置',
        groupName: '通栏设置',
    },
    Search: {
        id: '20005',
        name: 'Search',
        type: 'struct',
        title: '通用搜索',
        groupName: '通用搜索',
    },
    mainImage: {
        id: '221733',
        name: 'mainImage',
        type: 'static',
        title: '主图',
        groupName: 'mainImage'
    },
    NewsList: {
        id: '285851',
        name: 'NewsList',
        type: 'recommend',
        title: '要闻',
        groupName: 'box1'
    },
    Banner1: {
        id: '221734',
        name: 'Banner1',
        type: 'static',
        title: 'banner1',
        groupName: 'box1'
    },
    Swiper1: {
        id: '285852',
        name: 'Swiper1',
        type: 'recommend',
        title: '焦点图',
        groupName: 'box1'
    },
    Banner2: {
        id: '221735',
        name: 'Banner2',
        type: 'static',
        title: 'banner2',
        groupName: 'box1'
    },
    VideoList: {
        id: '285853',
        name: 'VideoList',
        type: 'recommend',
        title: '视频列表',
        groupName: 'box1'
    },
    Banner3: {
        id: '221736',
        name: 'Banner3',
        type: 'static',
        title: 'banner3',
        groupName: 'box2'
    },
    Kaimu1: {
        id: '285867',
        name: 'Kaimu1',
        type: 'recommend',
        title: '开幕演讲1',
        groupName: 'box2'
    },
    Banner4: {
        id: '221737',
        name: 'Banner4',
        type: 'static',
        title: 'banner4',
        groupName: 'box3'
    },
    Kaimu2: {
        id: '285868',
        name: 'Kaimu2',
        type: 'recommend',
        title: '开幕演讲2',
        groupName: 'box3'
    },
    Banner5: {
        id: '221738',
        name: 'Banner5',
        type: 'static',
        title: 'banner5',
        groupName: 'box4'
    },
    Kaimu3: {
        id: '285869',
        name: 'Kaimu3',
        type: 'recommend',
        title: '开幕演讲3',
        groupName: 'box4'
    },
    Banner6: {
        id: '221739',
        name: 'Banner6',
        type: 'static',
        title: 'banner6',
        groupName: 'box5'
    },
    Luntan: {
        id: '285866',
        name: 'Luntan',
        type: 'recommend',
        title: '五大论坛',
        groupName: 'box5'
    },
    Banner7: {
        id: '221740',
        name: 'Banner7',
        type: 'static',
        title: 'banner7',
        groupName: 'box6'
    },
    Double: {
        id: '285854',
        name: 'Double',
        type: 'recommend',
        title: '双列',
        groupName: 'box6'
    },
    Banner8: {
        id: '221741',
        name: 'Banner8',
        type: 'static',
        title: 'banner8',
        groupName: 'box7'
    },
    Grid1: {
        id: '285855',
        name: 'Grid1',
        type: 'recommend',
        title: 'Grid1',
        groupName: 'box7'
    },
    Banner9: {
        id: '221742',
        name: 'Banner9',
        type: 'static',
        title: 'banner9',
        groupName: 'box8'
    },
    Grid2: {
        id: '285856',
        name: 'Grid2',
        type: 'recommend',
        title: 'Grid2',
        groupName: 'box8'
    },
    Banner10: {
        id: '221743',
        name: 'Banner10',
        type: 'static',
        title: 'banner10',
        groupName: 'box9'
    },
    Grid3: {
        id: '285857',
        name: 'Grid3',
        type: 'recommend',
        title: 'Grid3',
        groupName: 'box9'
    },
    Banner11: {
        id: '221744',
        name: 'Banner11',
        type: 'static',
        title: 'banner11',
        groupName: 'box10'
    },
    Grid4: {
        id: '285858',
        name: 'Grid4',
        type: 'recommend',
        title: 'Grid4',
        groupName: 'box10'
    },
    Banner12: {
        id: '221745',
        name: 'Banner12',
        type: 'static',
        title: 'banner12',
        groupName: 'box11'
    },
    Grid5: {
        id: '285859',
        name: 'Grid5',
        type: 'recommend',
        title: 'Grid5',
        groupName: 'box11'
    },
    Banner13: {
        id: '221746',
        name: 'Banner13',
        type: 'static',
        title: 'banner13',
        groupName: 'box12'
    },
    Double2: {
        id: '285860',
        name: 'Double',
        type: 'recommend',
        title: '双列2',
        groupName: 'box12'
    },
    Banner14: {
        id: '221747',
        name: 'Banner14',
        type: 'static',
        title: 'banner14',
        groupName: 'box13'
    },
    TuPianCeHua: {
        id: '260217',
        name: 'TuPianCeHua',
        type: 'struct',
        title: '图片策划',
        groupName: 'box13'
    },
    Banner15: {
        id: '221748',
        name: 'Banner15',
        type: 'static',
        title: 'banner15',
        groupName: 'box14'
    },
    LargeVideoList: {
        id: '285865',
        name: 'LargeVideoList',
        type: 'recommend',
        title: '大视频列表',
        groupName: 'box14'
    },
    Banner16: {
        id: '221749',
        name: 'Banner16',
        type: 'static',
        title: 'banner16',
        groupName: 'box15'
    },
    Jingcaishunjian: {
        id: '260222',
        name: 'Jingcaishunjian',
        type: 'struct',
        title: '精彩瞬间',
        groupName: 'box15'
    },
    Banner17: {
        id: '221750',
        name: 'Banner17',
        type: 'static',
        title: 'banner17',
        groupName: 'box16'
    },
    GaoQingDaTu: {
        id: '285861',
        name: 'GaoQingDaTu',
        type: 'recommend',
        title: '高清大图',
        groupName: 'box16'
    },
    Banner18: {
        id: '221751',
        name: 'Banner18',
        type: 'static',
        title: 'banner18',
        groupName: 'box17'
    },
    Yicheng: {
        id: '260231',
        name: 'Yicheng',
        type: 'struct',
        title: '会议议程',
        groupName: 'box17'
    },
    Banner19: {
        id: '221752',
        name: 'Banner19',
        type: 'static',
        title: 'banner19',
        groupName: 'box18'
    },
    NewsULTitle1: {
        id: '260219',
        name: 'NewsULTitle1',
        type: 'struct',
        title: '相关报道标题1',
        groupName: 'box18'
    },
    NewsUL1: {
        id: '285862',
        name: 'NewsUL1',
        type: 'recommend',
        title: '相关报道1',
        groupName: 'box18'
    },
    NewsULTitle2: {
        id: '260220',
        name: 'NewsULTitle2',
        type: 'struct',
        title: '相关报道标题2',
        groupName: 'box18'
    },
    NewsUL2: {
        id: '285863',
        name: 'NewsUL2',
        type: 'recommend',
        title: '相关报道2',
        groupName: 'box18'
    },
    NewsULTitle3: {
        id: '260221',
        name: 'NewsULTitle3',
        type: 'struct',
        title: '相关报道标题3',
        groupName: 'box18'
    },
    NewsUL3: {
        id: '285864',
        name: 'NewsUL3',
        type: 'recommend',
        title: '相关报道3',
        groupName: 'box18'
    },
    Support: {
        id: '260226',
        name: 'Support',
        type: 'struct',
        title: '赞助列表',
        groupName: 'box18'
    },
    Banner20: {
        id: '221754',
        name: 'Banner20',
        type: 'static',
        title: 'banner20',
        groupName: 'box19'
    },
    Luntan2: {
        id: '285870',
        name: 'Luntan',
        type: 'recommend',
        title: '五大论坛2',
        groupName: 'box19'
    },
    Banner21: {
        id: '221755',
        name: 'Banner21',
        type: 'static',
        title: 'banner21',
        groupName: 'box20'
    },
    Luntan3: {
        id: '285871',
        name: 'Luntan',
        type: 'recommend',
        title: '五大论坛3',
        groupName: 'box20'
    },
    Banner22: {
        id: '221757',
        name: 'Banner22',
        type: 'static',
        title: 'banner22',
        groupName: 'box21'
    },
    SpecialSupport: {
        id: '221758',
        name: 'SpecialSupport',
        type: 'static',
        title: '特别支持',
        groupName: 'box21'
    },
    ad1: {
        name: 'ad1',
        id: 'adchip_finance/s_finance_dzxmindex_220610_ad_banner_01.inc.html',
        type: 'ad',
        title: '通栏广告1'
    },
};

module.exports = { ChipMap };
